export * from "./user-can-delete.directive";
